<template>
  <b-container>
    <b-row
      v-if="!hideSearchGroup"
      class="px-5 pt-3 sticky-top"
      style="background: white; z-index: 99"
    >
      <b-col sm="auto">
        <b-row align-h="start">
          <b-col sm="auto">
            <b-input-group class="search-group">
              <b-input-group-prepend>
                <span class="input-group-text">
                  <b-icon icon="search" />
                </span>
              </b-input-group-prepend>
              <b-form-input
                @keyup="debounceLogs"
                @search="debounceLogs"
                class="worklog-search-input"
                type="search"
                v-model="filter.terms"
                placeholder="Search"
              />
            </b-input-group>
          </b-col>
          <b-col sm="auto">
            <multiselect
              style="min-width: 240px"
              :show-labels="false"
              v-model="filter.types"
              :options="workTypeOptionsList.map((i) => i.id)"
              :custom-label="
                (opt) => workTypeOptionsList.find((x) => x.id == opt).name
              "
              :hide-selected="false"
              :close-on-select="false"
              :multiple="true"
              :internal-search="false"
              :searchable="false"
              placeholder="By Work Type"
            >
            </multiselect>
          </b-col>
          <b-col sm="auto">
            <multiselect
              v-if="workerId == null"
              style="min-width: 200px"
              :show-labels="false"
              v-model="filter.workers"
              :options="workerOptionsList.map((i) => i.worker_id)"
              :custom-label="
                (opt) =>
                  workerOptionsList.find((x) => x.worker_id == opt).worker_name
              "
              :hide-selected="false"
              :close-on-select="false"
              :multiple="true"
              :internal-search="false"
              :searchable="false"
              placeholder="By Worker"
            >
            </multiselect>
            <multiselect
              v-else
              class="mr-2"
              style="min-width: 200px"
              :show-labels="false"
              v-model="filter.claims"
              :options="worker_claims"
              :hide-selected="false"
              :close-on-select="false"
              :multiple="true"
              :internal-search="false"
              :searchable="false"
              placeholder="By Claim ID"
            >
            </multiselect>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols />
      <b-col v-if="!hideLogWorkButton" sm="auto" class="text-right">
        <b-button
          v-b-modal.new-worklog
          variant="outline-primary"
          class="avo-primary-btn"
        >
          Log Work
        </b-button>
        <work-log-add :claim="claim" @logAdded="getLogs()" :issues="issues" />
      </b-col>
    </b-row>
    <b-row>
      <b-col
        :xl="hideSearchGroup ? '11' : '10'"
        :class="[embedded ? 'pl-2' : 'pl-5', 'ml-4', 'mt-4']"
      >
        <div v-for="(worklog, index) in worklogs" :key="worklog.worklog_id">
          <div class="log-entry-container">
            <div class="circle-icon"></div>
            <div class="log-date">
              {{ formatDate(worklog.created) }}
              <span class="avo-text-light-small">{{
                formatTime(worklog.created)
              }}</span>
            </div>
            <div
              v-if="!clicked[index]"
              @click="selectLog(index)"
              class="worklog-card"
            >
              <div>
                <span
                  v-if="showClaimId && worklog.claim_id"
                  style="font-weight: 500"
                  >Claim #{{ worklog.claim_id }} - </span
                >{{
                  worklog.work_type == '-999'
                    ? worklog.title
                    : worklog.worktype_label
                }}
              </div>
              <div v-if="!(worklog.work_type == '-999')">
                <span class="avo-text-light-small mr-1">Logged by</span>
                {{ worklog.worker_name }}
              </div>
            </div>
            <div v-else class="worklog-clicked shadow">
              <div
                @click="selectLog(index)"
                class="
                  d-flex
                  justify-content-between
                  align-items-center
                  cursor-pointer
                  mb-2
                "
              >
                <div class="d-flex flex-column pt-3">
                  <div class="d-flex">
                    <div style="font-size: 16px">
                      <span
                        v-if="showClaimId && worklog.claim_id"
                        style="font-weight: 500"
                        >Claim #{{ worklog.claim_id }} - </span
                      >{{
                        worklog.work_type == "-999"
                          ? worklog.title
                          : worklog.worktype_label
                      }}
                    </div>
                  </div>
                </div>
                <div v-if="!(worklog.work_type == -999)" class="mt-3">
                  <span class="avo-text-light-small mr-2">Logged by</span>
                  <span style="font-size: 16px">{{ worklog.worker_name }}</span>
                </div>
              </div>
              <div v-if="worklog.work_type == '-999'" class="p-2">
                <b-row class="pl-3">
                  <b-col cols="9">
                    <b-row class="log-data-row mb-0" style="border: none">
                      <b-col cols="2" class="pl-0">
                        <span class="avo-text-bold">Notes</span>
                      </b-col>
                      <b-col cols="10">
                        <span class="avo-text-light">{{
                          worklog.description
                        }}</span>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
              <!-- submittal -->
              <div v-if="worklog.work_type == '0'" class="p-2">
                <b-row class="pl-3">
                  <b-col cols="9">
                    <b-row
                      v-if="worklog.submittal_type == 0"
                      class="log-data-row"
                    >
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Submitted to Payer</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{ worklog.payer_name ? worklog.payer_name : "N/A" }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row
                      v-if="worklog.submittal_type == 0"
                      class="log-data-row"
                    >
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Payer Address</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.payer_mailing_addr
                              ? worklog.payer_mailing_addr
                              : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row
                      v-if="worklog.submittal_type == 1"
                      class="log-data-row"
                    >
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold"
                          >Submitted to Clearinghouse</span
                        >
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.clearinghouse_name
                              ? worklog.clearinghouse_name
                              : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Notes</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.description ? worklog.description : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row
                      v-if="worklog.task"
                      class="log-data-row mb-0"
                      style="border: none"
                    >
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Next Followup</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <span class="avo-text-light" style="font-weight: 500"
                          >"{{ worklog.task.title }}"</span
                        >
                        <span class="avo-text-light">
                          due {{ formatDate(worklog.task.due_date) }} at
                          {{ formatTime(worklog.task.due_date) }}</span
                        >
                        <span class="avo-text-light"> </span>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
              <!-- insurance called -->
              <div v-if="worklog.work_type == '10'" class="p-2">
                <b-row class="pl-3">
                  <b-col cols="9">
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Payer</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{ worklog.payer_name ? worklog.payer_name : "N/A" }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Payer Phone</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.payer_phone ? worklog.payer_phone : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Rep Name</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{ worklog.rep_name ? worklog.rep_name : "N/A" }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Reference Number</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.reference_number
                              ? worklog.reference_number
                              : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Issue</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{ worklog.issue_text ? worklog.issue_text : "N/A" }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Resolution</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{ worklog.resolution ? worklog.resolution : "N/A" }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Notes</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.description ? worklog.description : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row
                      v-if="worklog.task"
                      class="log-data-row mb-0"
                      style="border: none"
                    >
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Next Followup</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <span class="avo-text-light" style="font-weight: 500"
                          >"{{ worklog.task.title }}"</span
                        >
                        <span class="avo-text-light">
                          due {{ formatDate(worklog.task.due_date) }} at
                          {{ formatTime(worklog.task.due_date) }}</span
                        >
                        <span class="avo-text-light"> </span>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
              <!-- eob retrieved -->
              <div v-if="worklog.work_type == '20'" class="p-2">
                <b-row class="pl-3">
                  <b-col cols="9">
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Received By</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.payer_contact_type
                              ? optionsMap.payer_contact_types[
                                  worklog.payer_contact_type
                                ]
                              : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Amount</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.payment.amount
                              ? "$" +
                                worklog.payment.amount.toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                              : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Payment Date</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.payment.payment_date
                              ? formatDate(worklog.payment.payment_date)
                              : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Check/ETF Number</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.payment.invoice_no
                              ? worklog.payment.invoice_no
                              : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Payment Status</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{ worklog.posted ? "Posted" : "Not yet posted" }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Attachments</span>
                      </b-col>
                      <b-col
                        v-if="worklog.documents && worklog.documents.length > 0"
                        cols="9"
                        class="d-flex pl-0"
                      >
                        <div
                          v-for="document in worklog.documents"
                          :key="document.document_id"
                          class="filename-link mr-2"
                        >
                          <a role="button" @click="getDownloadUrl(document)">{{
                            document.filename
                          }}</a>
                        </div>
                      </b-col>
                      <b-col v-else cols="9" class="pl-0">
                        <div class="avo-text-light">N/A</div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Notes</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.description ? worklog.description : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row
                      v-if="worklog.task"
                      class="log-data-row mb-0"
                      style="border: none"
                    >
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Next Followup</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <span class="avo-text-light" style="font-weight: 500"
                          >"{{ worklog.task.title }}"</span
                        >
                        <span class="avo-text-light">
                          due {{ formatDate(worklog.task.due_date) }} at
                          {{ formatTime(worklog.task.due_date) }}</span
                        >
                        <span class="avo-text-light"> </span>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
              <!-- patient payment -->
              <div v-if="worklog.work_type == '30'" class="p-2">
                <b-row class="pl-3">
                  <b-col cols="9">
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Type</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div
                          v-if="worklog.payment.payment_source == '1'"
                          class="avo-text-light"
                        >
                          {{
                            worklog.payment.patient_payment_type
                              ? optionsMap.patient_payment_types[
                                  worklog.payment.patient_payment_type
                                ]
                              : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Method</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div
                          v-if="worklog.payment.payment_source == '1'"
                          class="avo-text-light"
                        >
                          {{
                            worklog.payment.patient_payment_method
                              ? optionsMap.patient_payment_methods[
                                  worklog.payment.patient_payment_method
                                ]
                              : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Amount</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.payment.amount
                              ? "$" +
                                worklog.payment.amount.toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                              : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Payment Date</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.payment.payment_date
                              ? formatDate(worklog.payment.payment_date)
                              : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Check/ETF Number</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.payment.invoice_no
                              ? worklog.payment.invoice_no
                              : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Payment Status</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{ worklog.posted ? "Posted" : "Not yet posted" }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Notes</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.description ? worklog.description : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row
                      v-if="worklog.task"
                      class="log-data-row mb-0"
                      style="border: none"
                    >
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Next Followup</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <span class="avo-text-light" style="font-weight: 500"
                          >"{{ worklog.task.title }}"</span
                        >
                        <span class="avo-text-light">
                          due {{ formatDate(worklog.task.due_date) }} at
                          {{ formatTime(worklog.task.due_date) }}</span
                        >
                        <span class="avo-text-light"> </span>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
              <!-- med records sent -->
              <div v-if="worklog.work_type == '40'" class="p-2">
                <b-row class="pl-3">
                  <b-col cols="9">
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Payer</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{ worklog.payer_name ? worklog.payer_name : "N/A" }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row
                      v-if="worklog.payer_contact_type"
                      class="log-data-row"
                    >
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Method</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          <span style="font-weight: 500"
                            >{{
                              optionsMap.payer_contact_types[
                                worklog.payer_contact_type
                              ]
                            }}:
                          </span>
                          {{
                            worklog.payer_contact_type == 0
                              ? worklog.payer_fax
                              : worklog.payer_contact_type == 1
                              ? worklog.payer_mailing_addr
                              : worklog.payer_portal
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Attachments</span>
                      </b-col>
                      <b-col
                        v-if="worklog.documents && worklog.documents.length > 0"
                        cols="9"
                        class="d-flex pl-0"
                      >
                        <div
                          v-for="document in worklog.documents"
                          :key="document.document_id"
                          class="filename-link mr-2"
                        >
                          <a role="button" @click="getDownloadUrl(document)">{{
                            document.filename
                          }}</a>
                        </div>
                      </b-col>
                      <b-col v-else cols="9" class="pl-0">
                        <div class="avo-text-light">N/A</div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Notes</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.description ? worklog.description : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row
                      v-if="worklog.task"
                      class="log-data-row mb-0"
                      style="border: none"
                    >
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Next Followup</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <span class="avo-text-light" style="font-weight: 500"
                          >"{{ worklog.task.title }}"</span
                        >
                        <span class="avo-text-light">
                          due {{ formatDate(worklog.task.due_date) }} at
                          {{ formatTime(worklog.task.due_date) }}</span
                        >
                        <span class="avo-text-light"> </span>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
              <!-- appealed claim -->
              <div v-if="worklog.work_type == '50'" class="p-2">
                <b-row class="pl-3">
                  <b-col cols="9">
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Payer</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{ worklog.payer_name ? worklog.payer_name : "N/A" }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row
                      v-if="worklog.payer_contact_type"
                      class="log-data-row"
                    >
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Submittal Method</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          <span style="font-weight: 500"
                            >{{
                              optionsMap.payer_contact_types[
                                worklog.payer_contact_type
                              ]
                            }}:
                          </span>
                          {{
                            worklog.payer_contact_type == 0
                              ? worklog.payer_fax
                              : worklog.payer_contact_type == 1
                              ? worklog.payer_mailing_addr
                              : worklog.payer_portal
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Issue</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{ worklog.issue_text ? worklog.issue_text : "N/A" }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Resolution</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{ worklog.resolution ? worklog.resolution : "N/A" }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Attachments</span>
                      </b-col>
                      <b-col
                        v-if="worklog.documents && worklog.documents.length > 0"
                        cols="9"
                        class="d-flex pl-0"
                      >
                        <div
                          v-for="document in worklog.documents"
                          :key="document.document_id"
                          class="filename-link mr-2"
                        >
                          <a role="button" @click="getDownloadUrl(document)">{{
                            document.filename
                          }}</a>
                        </div>
                      </b-col>
                      <b-col v-else cols="9" class="pl-0">
                        <div class="avo-text-light">N/A</div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Notes</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.description ? worklog.description : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row
                      v-if="worklog.task"
                      class="log-data-row mb-0"
                      style="border: none"
                    >
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Next Followup</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <span class="avo-text-light" style="font-weight: 500"
                          >"{{ worklog.task.title }}"</span
                        >
                        <span class="avo-text-light">
                          due {{ formatDate(worklog.task.due_date) }} at
                          {{ formatTime(worklog.task.due_date) }}</span
                        >
                        <span class="avo-text-light"> </span>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
              <div v-if="worklog.work_type == '70'" class="p-2">
                <b-row class="pl-3">
                  <b-col cols="9">
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Rebilled</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{ worklog.rebilled ? "Yes" : "No" }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Notes</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.description ? worklog.description : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                  </b-row>
              </div>
              <!-- print/mailed hfca -->
              <div v-if="worklog.work_type == '60'" class="p-2">
                <b-row class="pl-3">
                  <b-col cols="9">
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Already Mailed</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{ worklog.hcfa_mailed ? "Yes" : "No" }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row v-if="worklog.hcfa_mailed" class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Date mailed</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.mailed_date
                              ? formatDate(worklog.mailed_date)
                              : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row v-else class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Location</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.hcfa_location
                              ? worklog.hcfa_location
                              : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Attachments</span>
                      </b-col>
                      <b-col
                        v-if="worklog.documents && worklog.documents.length > 0"
                        cols="9"
                        class="d-flex pl-0"
                      >
                        <div
                          v-for="document in worklog.documents"
                          :key="document.document_id"
                          class="filename-link mr-2"
                        >
                          <a role="button" @click="getDownloadUrl(document)">{{
                            document.filename
                          }}</a>
                        </div>
                      </b-col>
                      <b-col v-else cols="9" class="pl-0">
                        <div class="avo-text-light">N/A</div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Notes</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.description ? worklog.description : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row
                      v-if="worklog.task"
                      class="log-data-row mb-0"
                      style="border: none"
                    >
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Next Followup</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <span class="avo-text-light" style="font-weight: 500"
                          >"{{ worklog.task.title }}"</span
                        >
                        <span class="avo-text-light">
                          due {{ formatDate(worklog.task.due_date) }} at
                          {{ formatTime(worklog.task.due_date) }}</span
                        >
                        <span class="avo-text-light"> </span>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
              <!-- secondary insurance -->
              <div v-if="worklog.work_type == '80'" class="p-2">
                <b-row class="pl-3">
                  <b-col cols="9">
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Payer</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{ worklog.payer_name ? worklog.payer_name : "N/A" }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row
                      v-if="worklog.payer_contact_type"
                      class="log-data-row"
                    >
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Submittal Method</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          <span style="font-weight: 500"
                            >{{
                              optionsMap.payer_contact_types[
                                worklog.payer_contact_type
                              ]
                            }}:
                          </span>
                          {{
                            worklog.payer_contact_type == 0
                              ? worklog.payer_fax
                              : worklog.payer_contact_type == 1
                              ? worklog.payer_mailing_addr
                              : worklog.payer_portal
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Date Sent</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.mailed_date
                              ? formatDate(worklog.mailed_date)
                              : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">EOB Retrieved?</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{ worklog.eob_retrieved ? "Yes" : "No" }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Notes</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.description ? worklog.description : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row
                      v-if="worklog.task"
                      class="log-data-row mb-0"
                      style="border: none"
                    >
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Next Followup</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <span class="avo-text-light" style="font-weight: 500"
                          >"{{ worklog.task.title }}"</span
                        >
                        <span class="avo-text-light">
                          due {{ formatDate(worklog.task.due_date) }} at
                          {{ formatTime(worklog.task.due_date) }}</span
                        >
                        <span class="avo-text-light"> </span>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
              <!-- corrected claim -->
              <div v-if="worklog.work_type == '90'" class="p-2">
                <b-row class="pl-3">
                  <b-col cols="9">
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">ICN Number</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{ worklog.icn_no ? worklog.icn_no : "N/A" }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Issue</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{ worklog.issue_text ? worklog.issue_text : "N/A" }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Resolution</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{ worklog.resolution ? worklog.resolution : "N/A" }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Notes</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.description ? worklog.description : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row
                      v-if="worklog.task"
                      class="log-data-row mb-0"
                      style="border: none"
                    >
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Next Followup</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <span class="avo-text-light" style="font-weight: 500"
                          >"{{ worklog.task.title }}"</span
                        >
                        <span class="avo-text-light">
                          due {{ formatDate(worklog.task.due_date) }} at
                          {{ formatTime(worklog.task.due_date) }}</span
                        >
                        <span class="avo-text-light"> </span>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
              <!-- payment pending -->
              <div v-if="worklog.work_type == '100'" class="p-2">
                <b-row class="pl-3">
                  <b-col cols="9">
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Payer</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{ worklog.payer_name ? worklog.payer_name : "N/A" }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Payer Address</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.payer_mailing_addr
                              ? worklog.payer_mailing_addr
                              : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Notes</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.description ? worklog.description : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row
                      v-if="worklog.task"
                      class="log-data-row mb-0"
                      style="border: none"
                    >
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Next Followup</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <span class="avo-text-light" style="font-weight: 500"
                          >"{{ worklog.task.title }}"</span
                        >
                        <span class="avo-text-light">
                          due {{ formatDate(worklog.task.due_date) }} at
                          {{ formatTime(worklog.task.due_date) }}</span
                        >
                        <span class="avo-text-light"> </span>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
              <!-- ready for sending -->
              <div v-if="worklog.work_type == '110'" class="p-2">
                <b-row class="pl-3">
                  <b-col cols="9">
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Action Taken</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.ready_for_sending_action
                              ? worklog.ready_for_sending_action
                              : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Notes</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.description ? worklog.description : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row
                      v-if="worklog.task"
                      class="log-data-row mb-0"
                      style="border: none"
                    >
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Next Followup</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <span class="avo-text-light" style="font-weight: 500"
                          >"{{ worklog.task.title }}"</span
                        >
                        <span class="avo-text-light">
                          due {{ formatDate(worklog.task.due_date) }} at
                          {{ formatTime(worklog.task.due_date) }}</span
                        >
                        <span class="avo-text-light"> </span>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
              <!-- ready for posting -->
              <div v-if="worklog.work_type == '120'" class="p-2">
                <b-row class="pl-3">
                  <b-col cols="9">
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Payer</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{ worklog.payer_name ? worklog.payer_name : "N/A" }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Payer Address</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.payer_mailing_addr
                              ? worklog.payer_mailing_addr
                              : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Amount</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.payment.amount
                              ? "$" +
                                worklog.payment.amount.toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                              : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Payment Date</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.payment.payment_date
                              ? formatDate(worklog.payment.payment_date)
                              : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Check/ETF Number</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.payment.invoice_no
                              ? worklog.payment.invoice_no
                              : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">EOB Type</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.eob_type
                              ? optionsMap.eob_types[worklog.eob_type]
                              : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Notified Poster?</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{ worklog.notified_poster ? "Yes" : "No" }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Notes</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.description ? worklog.description : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row
                      v-if="worklog.task"
                      class="log-data-row mb-0"
                      style="border: none"
                    >
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Next Followup</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <span class="avo-text-light" style="font-weight: 500"
                          >"{{ worklog.task.title }}"</span
                        >
                        <span class="avo-text-light">
                          due {{ formatDate(worklog.task.due_date) }} at
                          {{ formatTime(worklog.task.due_date) }}</span
                        >
                        <span class="avo-text-light"> </span>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
              <!-- Clearinghouse err/rejected -->
              <div v-if="worklog.work_type == '130'" class="p-2">
                <b-row class="pl-3">
                  <b-col cols="9">
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Clearinghouse Name</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.clearinghouse_name
                              ? worklog.clearinghouse_name
                              : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Error Type</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.clearinghouse_error_type
                              ? optionsMap.clearinghouse_error_types[
                                  worklog.clearinghouse_error_type
                                ]
                              : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Issue</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{ worklog.issue_text ? worklog.issue_text : "N/A" }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Resolution</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{ worklog.resolution ? worklog.resolution : "N/A" }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Notes</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.description ? worklog.description : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row
                      v-if="worklog.task"
                      class="log-data-row mb-0"
                      style="border: none"
                    >
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Next Followup</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <span class="avo-text-light" style="font-weight: 500"
                          >"{{ worklog.task.title }}"</span
                        >
                        <span class="avo-text-light">
                          due {{ formatDate(worklog.task.due_date) }} at
                          {{ formatTime(worklog.task.due_date) }}</span
                        >
                        <span class="avo-text-light"> </span>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
              <!-- Pending adjustments/write-off -->
              <div v-if="worklog.work_type == '140'" class="p-2">
                <b-row class="pl-3">
                  <b-col cols="9">
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Adjustment Type</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.adjustment_type
                              ? optionsMap.adjustment_types[
                                  worklog.adjustment_type
                                ]
                              : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Adjustment Date</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.adjustment_date
                              ? formatDate(worklog.adjustment_date)
                              : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Amount</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.adjustment_amount
                              ? "$" +
                                worklog.adjustment_amount.toLocaleString(
                                  "en-US",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )
                              : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Reviewed/Approved By</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.approved_by_name
                              ? worklog.approved_by_name
                              : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Notes</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.description ? worklog.description : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row
                      v-if="worklog.task"
                      class="log-data-row mb-0"
                      style="border: none"
                    >
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Next Followup</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <span class="avo-text-light" style="font-weight: 500"
                          >"{{ worklog.task.title }}"</span
                        >
                        <span class="avo-text-light">
                          due {{ formatDate(worklog.task.due_date) }} at
                          {{ formatTime(worklog.task.due_date) }}</span
                        >
                        <span class="avo-text-light"> </span>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
              <!-- Reviewed Denial -->
              <div v-if="worklog.work_type == '150'" class="p-2">
                <b-row class="pl-3">
                  <b-col cols="9">
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Denial Type</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.denial_type
                              ? optionsMap.denial_types[worklog.denial_type]
                              : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Issue</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{ worklog.issue_text ? worklog.issue_text : "N/A" }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Resolution</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{ worklog.resolution ? worklog.resolution : "N/A" }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Notes</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.description ? worklog.description : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row
                      v-if="worklog.task"
                      class="log-data-row mb-0"
                      style="border: none"
                    >
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Next Followup</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <span class="avo-text-light" style="font-weight: 500"
                          >"{{ worklog.task.title }}"</span
                        >
                        <span class="avo-text-light">
                          due {{ formatDate(worklog.task.due_date) }} at
                          {{ formatTime(worklog.task.due_date) }}</span
                        >
                        <span class="avo-text-light"> </span>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
              <!-- Claim Not ON file -->
              <div v-if="worklog.work_type == '160'" class="p-2">
                <b-row class="pl-3">
                  <b-col cols="9">
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Verified</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.verified_where
                              ? worklog.verified_where
                              : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row
                      v-if="worklog.payer_contact_type"
                      class="log-data-row mb-0"
                      style="border: none"
                    >
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Resubmittal Method</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          <span style="font-weight: 500"
                            >{{
                              optionsMap.payer_contact_types[
                                worklog.payer_contact_type
                              ]
                            }}:
                          </span>
                          {{
                            worklog.payer_contact_type == 0
                              ? worklog.payer_fax
                              : worklog.payer_contact_type == 1
                              ? worklog.payer_mailing_addr
                              : worklog.payer_portal
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Confirmation Number</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.resubmittal_confirmation_no
                              ? worklog.resubmittal_confirmation_no
                              : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold"
                          >Claim Logged in Clearinghouse?</span
                        >
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{ worklog.log_in_clearinghouse ? "Yes" : "No" }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Notes</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.description ? worklog.description : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row
                      v-if="worklog.task"
                      class="log-data-row mb-0"
                      style="border: none"
                    >
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Next Followup</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <span class="avo-text-light" style="font-weight: 500"
                          >"{{ worklog.task.title }}"</span
                        >
                        <span class="avo-text-light">
                          due {{ formatDate(worklog.task.due_date) }} at
                          {{ formatTime(worklog.task.due_date) }}</span
                        >
                        <span class="avo-text-light"> </span>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
              <!-- In Dispute -->
              <div v-if="worklog.work_type == '170'" class="p-2">
                <b-row class="pl-3">
                  <b-col cols="9">
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Last Submission Date</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.last_submitted_date
                              ? formatDate(worklog.last_submitted_date)
                              : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Reference Number</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.reference_number
                              ? worklog.reference_number
                              : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Issue</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{ worklog.issue_text ? worklog.issue_text : "No" }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Notes</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.description ? worklog.description : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row
                      v-if="worklog.task"
                      class="log-data-row mb-0"
                      style="border: none"
                    >
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Next Followup</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <span class="avo-text-light" style="font-weight: 500"
                          >"{{ worklog.task.title }}"</span
                        >
                        <span class="avo-text-light">
                          due {{ formatDate(worklog.task.due_date) }} at
                          {{ formatTime(worklog.task.due_date) }}</span
                        >
                        <span class="avo-text-light"> </span>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
              <!-- Coding -->
              <div v-if="worklog.work_type == '180'" class="p-2">
                <b-row class="pl-3">
                  <b-col cols="9">
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Coding Error</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.coding_error
                              ? optionsMap.coding_errors[worklog.coding_error]
                              : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row
                      class="log-data-row"
                      v-if="worklog.cpt_codes.length > 0"
                    >
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Updated CPT Codes</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <b-row
                          v-for="code in worklog.cpt_codes"
                          :key="code.code"
                        >
                          <b-col cols="2">
                            {{ code.code }}
                          </b-col>
                          <b-col cols="10" class="avo-text-light">
                            {{ code.long }}
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                    <b-row
                      class="log-data-row"
                      v-if="worklog.icd_codes.length > 0"
                    >
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Updated ICD Codes</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <b-row
                          v-for="code in worklog.icd_codes"
                          :key="code.code"
                        >
                          <b-col cols="2">
                            {{ code.code }}
                          </b-col>
                          <b-col cols="10" class="avo-text-light">
                            {{ code.description }}
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Coding Updated By</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <span class="avo-text-light">{{
                          worklog.codes_changed_by
                            ? worklog.codes_changed_by
                            : "N/A"
                        }}</span>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Reason</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <span class="avo-text-light">{{
                          worklog.description ? worklog.description : "N/A"
                        }}</span>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Notes</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.description ? worklog.description : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row
                      v-if="worklog.task"
                      class="log-data-row mb-0"
                      style="border: none"
                    >
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Next Followup</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <span class="avo-text-light" style="font-weight: 500"
                          >"{{ worklog.task.title }}"</span
                        >
                        <span class="avo-text-light">
                          due {{ formatDate(worklog.task.due_date) }} at
                          {{ formatTime(worklog.task.due_date) }}</span
                        >
                        <span class="avo-text-light"> </span>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
              <!-- Resolved - Other -->
              <div v-if="worklog.work_type == '190'" class="p-2">
                <b-row class="pl-3">
                  <b-col cols="9">
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Notes</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.description ? worklog.description : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row
                      v-if="worklog.task"
                      class="log-data-row mb-0"
                      style="border: none"
                    >
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Next Followup</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <span class="avo-text-light" style="font-weight: 500"
                          >"{{ worklog.task.title }}"</span
                        >
                        <span class="avo-text-light">
                          due {{ formatDate(worklog.task.due_date) }} at
                          {{ formatTime(worklog.task.due_date) }}</span
                        >
                        <span class="avo-text-light"> </span>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
              <!-- Resolved - Paid -->
              <div v-if="worklog.work_type == '200'" class="p-2">
                <b-row class="pl-3">
                  <b-col cols="9">
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Notes</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.description ? worklog.description : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row
                      v-if="worklog.task"
                      class="log-data-row mb-0"
                      style="border: none"
                    >
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Next Followup</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <span class="avo-text-light" style="font-weight: 500"
                          >"{{ worklog.task.title }}"</span
                        >
                        <span class="avo-text-light">
                          due {{ formatDate(worklog.task.due_date) }} at
                          {{ formatTime(worklog.task.due_date) }}</span
                        >
                        <span class="avo-text-light"> </span>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
              <!-- Insurance Reprocessing -->
              <div v-if="worklog.work_type == '210'" class="p-2">
                <b-row class="pl-3">
                  <b-col cols="9">
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Payer</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{ worklog.payer_name ? worklog.payer_name : "N/A" }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Payer Address</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.payer_mailing_addr
                              ? worklog.payer_mailing_addr
                              : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Reference Number</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.reference_number
                              ? worklog.reference_number
                              : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Issue</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{ worklog.issue_text ? worklog.issue_text : "N/A" }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Resolution</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{ worklog.resolution ? worklog.resolution : "N/A" }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="log-data-row">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Notes</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.description ? worklog.description : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row
                      v-if="worklog.task"
                      class="log-data-row mb-0"
                      style="border: none"
                    >
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Next Followup</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <span class="avo-text-light" style="font-weight: 500"
                          >"{{ worklog.task.title }}"</span
                        >
                        <span class="avo-text-light">
                          due {{ formatDate(worklog.task.due_date) }} at
                          {{ formatTime(worklog.task.due_date) }}</span
                        >
                        <span class="avo-text-light"> </span>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
              <!-- Other -->
              <div v-if="worklog.work_type == '900'" class="p-2">
                <b-row class="pl-3">
                  <b-col cols="9">
                    <b-row class="log-data-row mb-0" style="border: none">
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Notes</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <div class="avo-text-light">
                          {{
                            worklog.description ? worklog.description : "N/A"
                          }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row
                      v-if="worklog.task"
                      class="log-data-row mb-0"
                      style="border: none"
                    >
                      <b-col cols="3" class="pl-0">
                        <span class="avo-text-bold">Next Followup</span>
                      </b-col>
                      <b-col cols="9" class="pl-0">
                        <span class="avo-text-light" style="font-weight: 500"
                          >"{{ worklog.task.title }}"</span
                        >
                        <span class="avo-text-light">
                          due {{ formatDate(worklog.task.due_date) }} at
                          {{ formatTime(worklog.task.due_date) }}</span
                        >
                        <span class="avo-text-light"> </span>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-overlay
      v-if="logsLoading"
      :show="logsLoading"
      variant="white"
      style="min-height: 200px"
    ></b-overlay>
    <b-row v-if="worklogs.length > 0 && totalRows > perPage && !hidePagination">
      <b-col :xl="hideSearchGroup ? '11' : '9'" class="pl-5 ml-4">
        <b-pagination
          :total-rows="totalRows"
          :per-page="perPage"
          v-model="currentPage"
          align="center"
        />
      </b-col>
    </b-row>
    <b-row v-if="worklogs.length == 0 && !logsLoading" class="text-center">
      <b-col class="avo-text-info"> No worklogs found </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {
  make_url,
  authenticated_request,
  alertsMixin,
  debounce,
  formatFullDate as formatDate,
  formatTime,
} from "../../common.js";
import Multiselect from "vue-multiselect";
import WorkLogAdd from "./WorkLogAdd.vue";

export default {
  name: "WorkLog",
  mixins: [alertsMixin],
  components: {
    WorkLogAdd,
    Multiselect,
  },
  props: [
    "hideSearchGroup",
    "hidePagination",
    "logsPerPage",
    "issues",
    "embedded",
    // used for the worker summary screen
    "logData",
    "workerId",
    "hideLogWorkButton",
    "showClaimId",
  ],
  data() {
    return {
      worklogs: [],
      initialWorklog: {
        title: "Claim was added to the system",
        description: "This is an initial, auto-generated work log.",
        work_type: -999,
      },
      clicked: [],
      filter: {
        terms: "",
        types: [],
        workers: [],
        claims: [],
      },
      formattedParams: {
        types: "",
        workers: "",
        claims: "",
      },
      perPage: this.logsPerPage ? this.logsPerPage : null,
      currentPage: 1,
      totalRows: "",
      optionsMap: {},
      workTypeOptionsList: [],
      workerOptionsList: [],
      worker_claims: [],
      logsLoading: true,
    };
  },
  methods: {
    formatDate,
    formatTime,
    getLogs: function () {
      var params = {
        search_terms: this.filter.terms,
        source_workers: this.formattedParams.workers,
        work_types: this.formattedParams.types,
        claim_ids: this.formattedParams.claims,
      };
      if (this.claim) {
        params["claim_id"] = this.claim.claim_id;
      }
      if (this.workerId) {
        params["source_workers"] = this.workerId.toString();
      }
      params.per_page = this.perPage;
      params.page = this.currentPage;

      const vm = this;
      const url = make_url("/worklogs");
      const promise = authenticated_request({
        method: "get",
        url: url,
        params: params,
      })
        .then(function (response) {
          const pagination = response.data.pagination;
          vm.totalRows = pagination.total;
          vm.perPage = pagination.per_page;

          var options = response.data.options_map;
          vm.optionsMap = options;
          vm.workTypeOptionsList = Object.keys(options.worklog_types).map(
            (key) => ({ id: Number(key), name: options.worklog_types[key] })
          );

          const items = response.data.worklogs;
          // console.log(items)
          vm.worklogs = items;
          if (vm.claim) {
            vm.initialWorklog.created = vm.claim.created;
          }

          // If last page or no logs, append the initial worklog
          if (
            vm.claim &&
            (pagination.page === pagination.page_count ||
              pagination.total === 0)
          ) {
            vm.totalRows += 1;
            vm.worklogs.push(vm.initialWorklog);
          }
          return items || [];
        })
        .catch(function (error) {
          console.log(error.response.data);
        })
        .finally(() => {
          vm.logsLoading = false;
        });
      return promise;
    },
    selectLog: function (index) {
      if (this.worklogs[index].work_type == "17" && !this.clicked[index]) {
        this.getLogCodes(this.worklogs[index].worklog_id, index);
      } else {
        this.$set(this.clicked, index, !this.clicked[index]);
      }
    },
    getLogCodes: function (worklog_id, index) {
      var params = {
        worklog_id: worklog_id,
      };
      if (this.claim) {
        params["claim_id"] = this.claim.claim_id;
      }
      if (this.workerId) {
        params["source_workers"] = this.workerId.toString();
      }
      const vm = this;
      const url = make_url("/worklogs/codes");
      authenticated_request({
        method: "get",
        params: params,
        url: url,
      }).then(function (response) {
        vm.worklogs[index].cpt_codes = response.data.cpt_codes;
        vm.worklogs[index].icd_codes = response.data.icd_codes;
        vm.$set(vm.clicked, index, !vm.clicked[index]);
        return response.data;
      });
    },
    getDownloadUrl(document) {
      const vm = this;
      const url = make_url("/documents/" + document.document_id + "/download");
      const promise = authenticated_request({
        method: "get",
        url: url,
      }).then(
        function (response) {
          const fullUrl = new URL(response.data, process.env.VUE_APP_API_URL);
          vm.downloadFile(fullUrl, document.filename);
        },
        function (error) {
          console.log(error);
        }
      );
      return promise;
    },
    downloadFile(url, filename) {
      const vm = this;
      const promise = authenticated_request({
        method: "get",
        url: url,
        responseType: "blob",
      })
        .then(function (response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
        })
        .catch(function (error) {
          if (error.response.status == 404) {
            vm.$emit("docNotFoundError");
          } else {
            vm.$emit("docDownloadError");
          }
        });
      return promise;
    },
    getAssociatedWorkers() {
      const vm = this;
      const url = make_url("/worklogs/workers");
      authenticated_request({
        method: "get",
        params: {
          claim_id: this.claim.claim_id,
        },
        url: url,
      }).then(function (response) {
        vm.workerOptionsList = response.data.workers;
        return response.data;
      });
    },
    getWorkerClaims: function () {
      const url = make_url("/workers/" + this.workerId + "/claims");
      const vm = this;
      const promise = authenticated_request({
        method: "get",
        url: url,
      })
        .then(function (response) {
          //get unique claim_ids
          var worker_claims = [
            ...new Set(response.data.claims.map((obj) => obj.claim_id)),
          ];
          vm.worker_claims = worker_claims || [];
          vm.setShowAlert(false);
          return worker_claims || [];
        })
        .catch(function (errors) {
          vm.setShowAlert(true, errors);
        });

      return promise;
    },
  },
  computed: {
    claim() {
      return this.$store.state.claims.workedClaim;
    },
    refreshWorkLogSummary() {
      return this.$store.state.claims.reloadWorkLogSummary;
    },
  },
  watch: {
    currentPage: function () {
      this.getLogs();
    },
    "filter.types": function (newValues) {
      this.formattedParams.types = newValues.join(",");
      this.getLogs();
    },
    "filter.workers": function (newValues) {
      this.formattedParams.workers = newValues.join(",");
      this.getLogs();
    },
    "filter.claims": function (newValues) {
      this.formattedParams.claims = newValues.join(",");
      this.getLogs();
    },
    logData: function () {
      this.worklogs = this.logData;
      this.logsLoading = false;
    },
    refreshWorkLogSummary(newState) {
      if (newState && this.embedded) {
        this.getLogs();
        this.$store.commit("workLogSummaryRefreshed");
      }
    },
  },
  async mounted() {
    // if log data comes from parent component (worker summary)
    if (this.logData) {
      this.worklogs = this.logData;
      this.logsLoading = false;
    } else {
      this.getLogs();
      if (this.workerId) {
        this.getWorkerClaims();
      } else {
        this.getAssociatedWorkers();
      }
    }
  },
  created() {
    this.debounceLogs = debounce(this.getLogs, 800);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* Styling the search bar group */
::v-deep .search-group {
  position: relative;
  border: 1px solid #c9d2df;
  border-radius: 5px;
  max-width: 200px;
  height: 43px;
}
::v-deep .worklog-search-input,
.input-group-text {
  height: 40px;
  border: none;
  border-radius: 5px;
  background: transparent;
  color: #9ca3ad;
}
::v-deep .worklog-search-input::placeholder {
  color: #9ca3ad;
  font-size: 12px;
  opacity: 1;
}
::v-deep .multiselect__input,
.multiselect__single {
  min-height: 25px !important;
}
.log-entry-container {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-height: 90px;
  padding-left: 20px;
  border-left: 1px solid var(--dark);
}
.log-date {
  margin-top: -4px;
  padding-bottom: 5px;
  font-size: 14px;
  font-weight: 500;
}
.circle-icon {
  min-width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid #7551e9;
  position: absolute;
  background-color: #f1edfc;
  top: -4px;
  left: -10px;
}
.log-data-row {
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid #c9d2df;
}
.data-card {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 40px;
  margin-right: 0;
  border-radius: 5px;
  padding: 0 10px;
  font-weight: 500;
  font-size: 14px;
  background: #e0ebf3 0% 0% no-repeat padding-box;
}
.worklog-container {
  margin-top: 25px;
}
.worklog-card {
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  border: 1px solid #e3ebf2;
  border-radius: 10px;
  background-color: #f7f8fa;
  cursor: pointer;
}
.worklog-clicked {
  padding: 0 20px 10px 20px;
  margin-bottom: 20px;
  z-index: 10;
  border: 1px solid #e3ebf2;
  border-radius: 10px;
  background-color: #f7f8fa;
  font-size: 14px;
}
.filename-link {
  color: var(--blue);
  font-size: 14px;
  /* text-align: center; */
}
</style>